export const integerAccept = /[\d]+/g
export const parseNumber = (str: string) => (str.match(integerAccept) || []).join("")
